export default __webpack_public_path__ + "static/media/Maidenhair-Fern_R1.4ffd3fcb.png";